import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { PERFORMANCE_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, PUT, DELETE } = HTTP_METHODS;
const {
  GET_PERFORMANCE,
  PUT_PERFORMANCE,
  POST_PERFORMANCE,
  DELETE_PERFORMANCE,
  GET_SIX_MONTH_PERFORMANCE,
  POST_KPI_PERFORMANCE_FILTER
} = PERFORMANCE_REQUEST;

export const performanceApi = createApi({
  reducerPath: 'performanceApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  endpoints: (builder) => ({
    getPerformance: builder.query({
      query: (data) => ({ url: `${GET_PERFORMANCE}${buildQueryString(data)}`, method: GET })
    }),
    addPerformance: builder.mutation({
      query: (data) => ({ url: POST_PERFORMANCE, method: POST, data })
    }),
    getKpiPerformanceByFilter: builder.query({
      query: (data) => ({
        url: `${POST_KPI_PERFORMANCE_FILTER}${buildQueryString(data)}`,
        method: GET
      })
    }),
    getSixMonthPerformance: builder.query({
      query: (data) => ({
        url: `${GET_SIX_MONTH_PERFORMANCE}${buildQueryString(data)}`,
        method: GET
      })
    }),
    deletePerformance: builder.mutation({
      query: (id) => ({
        url: `${DELETE_PERFORMANCE}/${id}`,
        method: DELETE
      })
    }),
    editPerformance: builder.mutation({
      query: (data) => ({
        url: `${PUT_PERFORMANCE}/${data.id}`,
        method: PUT,
        data: data.data
      })
    })
  })
});

export const {
  useGetPerformanceQuery,
  useAddPerformanceMutation,
  useEditPerformanceMutation,
  useDeletePerformanceMutation,
  useGetSixMonthPerformanceQuery,
  useGetKpiPerformanceByFilterQuery
} = performanceApi;
